// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import FormControl from '@mui/material/FormControl';
import { NumberField } from '../utils/input/numberField';
// Actions
import { updateNbOfIslandsIncluded } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitNbOfIslandsIncluded(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const nb_of_islands_included = useSelector((state: AppState) => state.circuit.nb_of_islands_included);

    useEffect(() => {
        dispatch(updateNbOfIslandsIncluded(nb_of_islands_included));
    },[circuitData]);

    const onNbOfIslandsIncludedChange = (event: { target: { value: any; }; }) => {
        dispatch(updateNbOfIslandsIncluded(event.target.value));

    };
    const resetValue = () => {
        if (isNaN(parseInt(String(nb_of_islands_included)))){
            dispatch(updateNbOfIslandsIncluded(0));
        }
    };

    useEffect(() => {
        if (props.circuit) {
            dispatch(updateNbOfIslandsIncluded(props.circuit.nb_of_islands_included ?? ''));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth variant={ 'outlined' }>
            <NumberField onBlur={resetValue}
                value={ nb_of_islands_included ?? '' }
                label={ t('shared.island-number') }
                onChange={ onNbOfIslandsIncludedChange }
            />
        </FormControl>
    );
}

export default CircuitNbOfIslandsIncluded;
